// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .incentives-selector--14c6m{--tile-selector-item-description-font-size:13px;--tile-selector-item-active-description-font-weight:normal;--tile-selector-min-height-desktop:80px;--tile-selector-min-height-mobile:60px;--skeleton-height:22px;--skeleton-width:10em;--skeleton-font-size:12px;font-size:inherit}", ""]);
// Exports
exports.locals = {
	"incentivesSelector": "incentives-selector--14c6m"
};
module.exports = exports;
